import React from "react";
import { Route, Link } from "react-router-dom";

function MenuLink({ label, to, activeOnlyWhenExact }) {
    return (
        <Route
            path={to}
            exact={activeOnlyWhenExact}
            children={({ match }) => (
                <li className={match ? "nav-item active" : "nav-item"}>
                    <Link className={match ? "nav-link active" : "nav-link"} to={to}>{label}</Link>
                </li>
            )}
        />
    );
}

export default MenuLink;